<template>
    <div class="mobile-footer tw-flex tw-justify-center tw-items-center">
        <p class="tw-mr-[0.16rem]">安徽微观信息科技有限公司</p>
        <img
            class="tw-w-[0.28rem] tw-h-[0.3rem] tw-mr-[0.08rem]"
            src="@/assets/home/ba_logo01.png"
        />
        <p class="tw-flex tw-justify-center tw-items-center">皖ICP备2021017992号-1</p>
    </div>
</template>

<script>
import { getOSSUrl } from '@/utils/index.js'

export default {
    name: 'MobileFooter',
    methods: {
        getOSSUrl,
    },
}
</script>

<style lang="less">
.mobile-footer {
    color: #919191;
    font-size: 0.24rem;
    line-height: 1;
    background-color: #222;
    padding: 0.28rem 0;
}
</style>
